import {XauditModel} from '../../xaudit.model';

export class NonWorkingDayModel extends XauditModel {
  public NonWorkDayID: string;
  public WorkRegionID: string;
  public NonWorkingYear: number;
  public NonWorkingDay: Date;
  public RecurringDays: string;

  constructor(nonWorkDayID: string, workRegionID: string, nonWorkingYear: number = null, nonWorkingDay: Date = null, recurringDays: string = null) {
    super();
    this.NonWorkDayID = nonWorkDayID;
    this.WorkRegionID = workRegionID;
    if (nonWorkingYear) {
      this.NonWorkingYear = nonWorkingYear;
    }

    if (nonWorkingDay) {
      this.NonWorkingDay = nonWorkingDay;
    }

    if (recurringDays) {
      this.RecurringDays = recurringDays;
    }
  }
}
